module.exports = __webpack_public_path__ + "static/media/Motorola Moto 360 Men Black + Black Closed.d5b74367.png";